<script setup>
import { RouterLink } from "vue-router";
import PostCard from "../components/PostCard.vue";
import LoadingSpinner from "../components/LoadingSpinner.vue";
</script>

<template>
    <div class="pageContent">
        <h1>News</h1>
        <div>
            <LoadingSpinner v-if="!loaded" text="Caricamento degli articoli..." />
        </div>
        <div v-if="loaded" class="row" id="newsList">
            <PostCard v-for="article in json" :data="article"></PostCard>
        </div>
    </div>
</template>

<script>
    export default {
    data() {
        return {
            json: null,
            loaded: false,
            months: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
        };
    },
    methods: {
        createMasonry: function () {
            /*var msnry = new Masonry("#newsList", {
                percentPosition: true,
                itemSelector: ".grid-item"
            });*/
        },
        unescapeHtml: function(html) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html.replace("<script>", "");
            return txt.value;
        }
    },
    created: function () {
        fetch("https://wp.fiesteinpais.it/wp-json/fiesteinpais/v1/posts")
            .then(r => r.json())
            .then(json => {
            this.json = json;
            console.log("[fiesteinpais] [frontend] Successfully got newslist.");
            this.loaded = true;
        });
    },
    components: { RouterLink }
}
</script>